// extracted by mini-css-extract-plugin
export default {"container":"fXfsbb","icon":"s8Vg0W","headline":"yEzDUa","xs":"d6FY6S","text":"iP0727","md":"xow_YO","lg":"qwmDue"};